<template>
  <div>
    <line-template-text v-if="messageContent.templateType === 'TEXT'" :content="messageContent.content"></line-template-text>
    <line-template-image v-if="messageContent.templateType === 'IMAGE'" :content="messageContent.content"></line-template-image>
    <line-template-image-text v-if="messageContent.templateType === 'RESTAURANT'" :content="messageContent.content"></line-template-image-text>
  </div>
</template>

<script>
import lineTemplateImageText from './line/templates/lineTemplateImageText'
import lineTemplateImage from './line/templates/lineTemplateImage'
import lineTemplateText from './line/templates/lineTemplateText'

export default {
  name: 'messageLine',
  props: [
    'senderType', 'content'
  ],
  components: {
    lineTemplateText, lineTemplateImageText, lineTemplateImage
  },
  computed: {
    customTextBoxStyle () {
      if (this.senderType === 'USER') {
        return 'msgLink fs-14 message-content-wrap'
      } else {
        return 'msgLink ma-0 chat-bubble even fs-14 message-content message-content-wrap wc-white-bg'
      }
    },
    messageContent () {
      return JSON.parse(this.content)
    }
  },
  mounted () {
    console.log(this.messageContent)
  },
  methods: {
  }
}
</script>

<style>
  .msgLink a {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/message_line.vue